module.exports = __webpack_public_path__ + "static/media/io.0b7d5f23.svg";